// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/nasalization-rg.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/nasalization-rg.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/nasalization-rg.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Bright blue from the star */
  --colorTertiary: #046eb6 !important;
  /* Deep navy background for contrast */
  --color-dark-background: #002d47 !important;
  /* Complementary to primary */
  --color-dark-border: #004270 !important;
  /* Light blue as highlight */
  --color-dark-text-accent: #add8e6 !important;
  /* Neutral gray for muted text */
  --color-dark-text-muted: #6b6b6b !important;
  /* Bright blue from the star */
  --color-primary: #046eb6 !important;
  /* Light blue accent */
  --color-primary-light: #add8e6 !important;
  /* Deep blue for accents */
  --color-primary-dark: #023456 !important;
}

#keeptrack-root {
  overflow: hidden;
  font-family: 'Open Sans', sans-serif;
  color: white;
  background: var(--color-dark-background);
  background: -moz-linear-gradient(45deg, var(--color-dark-background), var(--color-dark-background));
  background: -webkit-linear-gradient(45deg, var(--color-dark-background), var(--color-dark-background));
  background: linear-gradient(45deg, var(--color-dark-background), var(--color-dark-background));
}

.ui-icon-minus {
  margin: auto !important;
}

.ui-icon-plus {
  margin: auto !important;
}

.ui-datepicker td a {
  text-align: center !important;
}

#canvas-holder {
  display: none;
  /* Display none till loading is complete main.js -227 */
}

#loading-screen {
  display: flex;
  padding: 0;
  z-index: 101;
  text-align: center;
  background: #000000;
  color: white;
  /* Apply filter only to background image, not text */
  /* Use a pseudo-element for background image and filter */
  position: relative;
}

#loading-screen::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: inherit;
  filter: brightness(0.85) contrast(1.05);
  pointer-events: none;
}

.full-loader {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  bottom: 0;
  left: 0;
}

.mini-loader-container {
  background: rgba(0, 0, 0, 0) !important;
  position: absolute;
  width: 100%;
  height: 100%;
}

.mini-loader {
  border-radius: 35px;
  z-index: 101;
  border: 5px solid rgba(0, 0, 0, 0.3);
  width: 300px;
  padding-top: 25px;
  padding-bottom: 5px;
  overflow: hidden;
  background: var(--color-dark-background);
  background: -moz-linear-gradient(45deg, var(--colorTertiaryDarken4), var(--colorTertiary));
  background: -webkit-linear-gradient(45deg, var(--colorTertiaryDarken4), var(--colorTertiary));
  background: linear-gradient(45deg, var(--colorTertiaryDarken4), var(--colorTertiary));
  -moz-background-clip: padding;
  /* Firefox 3.6 */
  -webkit-background-clip: padding;
  /* Safari 4? Chrome 6? */
  background-clip: padding-box;
  /* Firefox 4, Safari 5, Opera 10, IE 9 */
}

#logo-inner-container {
  margin: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  height: 150px;
  z-index: 1;
}

#logo-text {
  display: block;
  font-size: 9vh;
  max-width: 60%;
  margin: auto;
  /* Large black drop shadow */
  -webkit-filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.75)) drop-shadow(0 0 10px rgba(0, 0, 0, 0.75));
  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.75)) drop-shadow(0 0 10px rgba(0, 0, 0, 0.75));
}

#logo-text-version {
  display: block;
  font-size: 9vh;
  padding-left: 50px;
  text-shadow:
    0px 0px 8px rgb(0 0 0),
    0px 0px 8px rgb(0 0 0);
  color: var(--colorPrimaryLighten2) !important;
}

#sponsor-text {
  display: block;
  font-size: 2em;
  text-shadow:
    0px 0px 8px rgb(0 0 0),
    0px 0px 8px rgb(0 0 0);
}

#sponsor-img {
  background: white;
  border-radius: 10px;
  padding: 5px;
  box-shadow:
    0px 0px 8px rgb(0 0 0),
    0px 0px 8px rgb(0 0 0);
}

@font-face {
  font-family: 'nasalization';
  font-style: normal;
  font-weight: 400;
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

.logo-font {
  font-family: 'nasalization', sans-serif;
  font-size: 8em;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

@media (max-width: 800px) {
  #logo-text {
    font-size: 3em;
  }

  #logo-text-version {
    font-size: 3em;
  }
}

#loader-text {
  display: block;
  line-height: 50px;
  text-shadow:
    0px 0px 8px rgb(0 0 0),
    0px 0px 8px rgb(0 0 0);
}

#loading-hint {
  text-align: left;
  z-index: 1;
  position: absolute;
  width: 100%;
  font-size: 1.2em;
  background-color: rgba(0, 0, 0, 0.5);
  padding-left: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  bottom: 15%;
  text-shadow:
    0px 0px 8px rgb(0 0 0),
    0px 0px 8px rgb(0 0 0);
}

#mobile-start-button {
  display: none;
  margin-top: 10px;
}

.start-hidden {
  display: none;
}

#start-app-btn {
  display: none;
  position: relative;
  font-size: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  animation: pulsate 1s infinite;
}

@keyframes pulsate {
  0% {
    box-shadow: 0 0 0 0 rgba(186, 22, 12, 0.7);
    transform: translateX(-50%) scale(1);
  }

  50% {
    box-shadow: 0 0 20px 10px rgba(186, 22, 12, 0.4);
    transform: translateX(-50%) scale(1.08);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(186, 22, 12, 0.7);
    transform: translateX(-50%) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./public/css/loading-screen.celestrak.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,sCAAsC;EACtC,2CAA2C;EAC3C,6BAA6B;EAC7B,uCAAuC;EACvC,4BAA4B;EAC5B,4CAA4C;EAC5C,gCAAgC;EAChC,2CAA2C;EAC3C,8BAA8B;EAC9B,mCAAmC;EACnC,sBAAsB;EACtB,yCAAyC;EACzC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,YAAY;EACZ,wCAAwC;EACxC,mGAAmG;EACnG,sGAAsG;EACtG,8FAA8F;AAChG;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oDAAoD;EACpD,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,OAAO;AACT;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,0FAA0F;EAC1F,6FAA6F;EAC7F,qFAAqF;EACrF,6BAA6B;EAC7B,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,kGAAkG;EAClG,0FAA0F;AAC5F;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB;;0BAEwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,cAAc;EACd;;0BAEwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ;;0BAEwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB;;;8DAGqD;AACvD;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB;;0BAEwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX;;0BAEwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE;IACE,0CAA0C;IAC1C,oCAAoC;EACtC;;EAEA;IACE,gDAAgD;IAChD,uCAAuC;EACzC;;EAEA;IACE,0CAA0C;IAC1C,oCAAoC;EACtC;AACF","sourcesContent":[":root {\n  /* Bright blue from the star */\n  --colorTertiary: #046eb6 !important;\n  /* Deep navy background for contrast */\n  --color-dark-background: #002d47 !important;\n  /* Complementary to primary */\n  --color-dark-border: #004270 !important;\n  /* Light blue as highlight */\n  --color-dark-text-accent: #add8e6 !important;\n  /* Neutral gray for muted text */\n  --color-dark-text-muted: #6b6b6b !important;\n  /* Bright blue from the star */\n  --color-primary: #046eb6 !important;\n  /* Light blue accent */\n  --color-primary-light: #add8e6 !important;\n  /* Deep blue for accents */\n  --color-primary-dark: #023456 !important;\n}\n\n#keeptrack-root {\n  overflow: hidden;\n  font-family: 'Open Sans', sans-serif;\n  color: white;\n  background: var(--color-dark-background);\n  background: -moz-linear-gradient(45deg, var(--color-dark-background), var(--color-dark-background));\n  background: -webkit-linear-gradient(45deg, var(--color-dark-background), var(--color-dark-background));\n  background: linear-gradient(45deg, var(--color-dark-background), var(--color-dark-background));\n}\n\n.ui-icon-minus {\n  margin: auto !important;\n}\n\n.ui-icon-plus {\n  margin: auto !important;\n}\n\n.ui-datepicker td a {\n  text-align: center !important;\n}\n\n#canvas-holder {\n  display: none;\n  /* Display none till loading is complete main.js -227 */\n}\n\n#loading-screen {\n  display: flex;\n  padding: 0;\n  z-index: 101;\n  text-align: center;\n  background: #000000;\n  color: white;\n  /* Apply filter only to background image, not text */\n  /* Use a pseudo-element for background image and filter */\n  position: relative;\n}\n\n#loading-screen::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: inherit;\n  filter: brightness(0.85) contrast(1.05);\n  pointer-events: none;\n}\n\n.full-loader {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  overflow: hidden;\n  top: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.mini-loader-container {\n  background: rgba(0, 0, 0, 0) !important;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.mini-loader {\n  border-radius: 35px;\n  z-index: 101;\n  border: 5px solid rgba(0, 0, 0, 0.3);\n  width: 300px;\n  padding-top: 25px;\n  padding-bottom: 5px;\n  overflow: hidden;\n  background: var(--color-dark-background);\n  background: -moz-linear-gradient(45deg, var(--colorTertiaryDarken4), var(--colorTertiary));\n  background: -webkit-linear-gradient(45deg, var(--colorTertiaryDarken4), var(--colorTertiary));\n  background: linear-gradient(45deg, var(--colorTertiaryDarken4), var(--colorTertiary));\n  -moz-background-clip: padding;\n  /* Firefox 3.6 */\n  -webkit-background-clip: padding;\n  /* Safari 4? Chrome 6? */\n  background-clip: padding-box;\n  /* Firefox 4, Safari 5, Opera 10, IE 9 */\n}\n\n#logo-inner-container {\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: center;\n  height: 150px;\n  z-index: 1;\n}\n\n#logo-text {\n  display: block;\n  font-size: 9vh;\n  max-width: 60%;\n  margin: auto;\n  /* Large black drop shadow */\n  -webkit-filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.75)) drop-shadow(0 0 10px rgba(0, 0, 0, 0.75));\n  filter: drop-shadow(0 0 6px rgba(0, 0, 0, 0.75)) drop-shadow(0 0 10px rgba(0, 0, 0, 0.75));\n}\n\n#logo-text-version {\n  display: block;\n  font-size: 9vh;\n  padding-left: 50px;\n  text-shadow:\n    0px 0px 8px rgb(0 0 0),\n    0px 0px 8px rgb(0 0 0);\n  color: var(--colorPrimaryLighten2) !important;\n}\n\n#sponsor-text {\n  display: block;\n  font-size: 2em;\n  text-shadow:\n    0px 0px 8px rgb(0 0 0),\n    0px 0px 8px rgb(0 0 0);\n}\n\n#sponsor-img {\n  background: white;\n  border-radius: 10px;\n  padding: 5px;\n  box-shadow:\n    0px 0px 8px rgb(0 0 0),\n    0px 0px 8px rgb(0 0 0);\n}\n\n@font-face {\n  font-family: 'nasalization';\n  font-style: normal;\n  font-weight: 400;\n  src:\n    url('fonts/nasalization-rg.woff2') format('woff2'),\n    url('fonts/nasalization-rg.woff') format('woff'),\n    url('fonts/nasalization-rg.ttf') format('truetype');\n}\n\n.logo-font {\n  font-family: 'nasalization', sans-serif;\n  font-size: 8em;\n  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n}\n\n@media (max-width: 800px) {\n  #logo-text {\n    font-size: 3em;\n  }\n\n  #logo-text-version {\n    font-size: 3em;\n  }\n}\n\n#loader-text {\n  display: block;\n  line-height: 50px;\n  text-shadow:\n    0px 0px 8px rgb(0 0 0),\n    0px 0px 8px rgb(0 0 0);\n}\n\n#loading-hint {\n  text-align: left;\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  font-size: 1.2em;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding-left: 5%;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  bottom: 15%;\n  text-shadow:\n    0px 0px 8px rgb(0 0 0),\n    0px 0px 8px rgb(0 0 0);\n}\n\n#mobile-start-button {\n  display: none;\n  margin-top: 10px;\n}\n\n.start-hidden {\n  display: none;\n}\n\n#start-app-btn {\n  display: none;\n  position: relative;\n  font-size: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  animation: pulsate 1s infinite;\n}\n\n@keyframes pulsate {\n  0% {\n    box-shadow: 0 0 0 0 rgba(186, 22, 12, 0.7);\n    transform: translateX(-50%) scale(1);\n  }\n\n  50% {\n    box-shadow: 0 0 20px 10px rgba(186, 22, 12, 0.4);\n    transform: translateX(-50%) scale(1.08);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(186, 22, 12, 0.7);\n    transform: translateX(-50%) scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
